import l10n from "../../lib/l10n";
import { useState } from "react";
import {
  Button,
  Checkbox,
  Box,
  Tooltip,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
} from "@mui/material";
import { useAppDialog } from "../../store/app-dialog";

export const CheckoutZoomDialog = ({ resolve, reject }) => {
  const [checked, setChecked] = useState(false);
  const { closeDialog } = useAppDialog();
  const onChange = (e) => {
    setChecked(e.target.checked);
  };

  const onClickBackButton = () => {
    reject();
    closeDialog();
  };

  const onClickGoButton = () => {
    resolve();
    closeDialog();
  };

  return (
    <>
      <DialogTitle>
        Attenzione!
      </DialogTitle>
      <DialogContent>
        <Box
          dangerouslySetInnerHTML={{ __html: l10n.ui_label_zoom_alert_message }}
          mb={2}
        />
        <FormControlLabel
          label={l10n.ui_label_zoom_alert_checkbox}
          control={<Checkbox checked={checked} onChange={onChange} />}
          sx={{
            "& .MuiFormControlLabel-label": {
              fontSize: '0.8em'
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClickBackButton}>
          Cancella
        </Button>
        <Tooltip
          title={!checked ? l10n.ui_label_zoom_alert_popper : ''}
          placement="left">
          <span>
            <Button
              variant="contained"
              color="success"
              disabled={!checked}
              onClick={onClickGoButton}>
              Continua
            </Button>
          </span>
        </Tooltip>
      </DialogActions>
    </>
  );
};
